// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"128":"edb8c885","356":"f30697c8","560":"4c6a949b","689":"63e105fe","775":"8f4c6b96","850":"871c600e"}[chunkId] + ".css";
};